export interface OrderResolutionDimensions {
    width: number;
    height: number;
}

export const stringifyOrderResolutionDimensions = (res: OrderResolutionDimensions): string =>
    `${res.width} x ${res.height}`;
